import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import { GATrackEvent } from 'utils/googleAnalytics'

import type { TabbedNavItem } from 'types/microlearning'

const trackClick = (actionType: string) => {
  GATrackEvent({
    eventName: 'learning_activity',
    eventParams: {
      event_trigger: 'ab_test_tabbed_menu',
      action_type: actionType,
    },
    sendDefaultParams: true,
  })
}

const defaultNavItems: TabbedNavItem[] = [
  {
    name: 'untuk-anda',
    label: 'Untuk Anda',
    href: `/pelatihan-mandiri`,
  },
  {
    name: 'topik',
    label: 'Topik',
    href: `/pelatihan-mandiri/daftar-topik`,
  },
  {
    name: 'aksi-nyata',
    label: 'Aksi Nyata',
    href: `/pelatihan-mandiri/daftar-aksi-nyata`,
  },
]

const TabbedNav = ({
  activeMenu,
  navItems = defaultNavItems,
  absolutePosition = false,
  className,
}: {
  activeMenu?: string
  navItems?: TabbedNavItem[]
  absolutePosition?: boolean
  className?: string
}) => {
  return (
    <div
      className={clsx(
        'left-1/2 -translate-x-1/2 w-full max-w-xl z-10 pb-[2px] bg-white -mt-0.5 overflow-hidden',
        absolutePosition ? 'absolute' : 'fixed',
        className
      )}
    >
      <div className="flex items-stretch -mx-2 h-9 shadow">
        {navItems.map(({ name, label, href }) => (
          <div key={name} className="px-2 flex-1 h-full text-center">
            <Link href={href} passHref>
              <Text
                data-testid={name}
                onClick={() => trackClick(name)}
                className={clsx(
                  'inline-block pb-2 border-b-4',
                  activeMenu === name
                    ? 'border-icon-informational'
                    : 'border-transparent'
                )}
                variant="action"
                color={activeMenu === name ? 'primary' : 'subdued'}
                as="a"
                href={href}
              >
                {label}
              </Text>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TabbedNav
